import axios from 'axios'
import router from '../router'

/*
|--------------------------------------------------------------------------
| Axios Base config
|--------------------------------------------------------------------------
|
*/
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL

/*
|--------------------------------------------------------------------------
| Axios Request Interceptor
|--------------------------------------------------------------------------
|
*/
axios.interceptors.request.use(
    (config) => {
        config.headers['Accept'] = 'application/json'
        const tokenImpersonate = localStorage.getItem('token_impersonate')
        let token = localStorage.getItem('token')
        token = tokenImpersonate ?? token
        if (token) config.headers['Authorization'] = `Bearer ${token}`

        return config
    },

    (error) => {
        return Promise.reject(error)
    }
)

/*
|--------------------------------------------------------------------------
| Axios Response Interceptor
|--------------------------------------------------------------------------
|
*/
axios.interceptors.response.use(
    function (response) {
        return response
    },
    function (error) {
        const url = error.config ? error.config.url : ''
        const isAuthRequest = url.includes('/api/tokens') || url.includes('/oauth/token') || url.includes('/api/forgot-password')
        if (error.response && error.response.status === 401 && !isAuthRequest) {
            localStorage.removeItem('token')
            router.push('/').catch(() => {})
        }
        if (error.response && error.response.status === 403 && !isAuthRequest && !error.config.silence403) {
            router.push('/403').catch(() => {})
        }
        if (error.response && error.response.status === 404 && !isAuthRequest) {
            router.push('/404').catch(() => {})
        }
        return Promise.reject(error)
    }
)

export default axios
